<h3>Verzekering opzeggen</h3>
<form (ngSubmit)="onSubmit()" [formGroup]="form">
    <wuc-form-field>
        <wuc-form-field-label>Per wanneer?</wuc-form-field-label>
        <div>
            <wuc-input-radio
                formControlName="endDateIndication"
                [value]="endDateIndicationEnum.Immediately"
            >Meteen opzeggen
            </wuc-input-radio>
            <wuc-input-radio
                formControlName="endDateIndication"
                [value]="endDateIndicationEnum.WithFutureDate"
            >Opzeggen met een datum in de toekomst
            </wuc-input-radio>
        </div>
    </wuc-form-field>
    <wuc-form-field *ngIf="endDateIndication.value === endDateIndicationEnum.WithFutureDate">
        <wuc-form-field-label>Wat is de laatste dag waarop u verzekerd wilt zijn?</wuc-form-field-label>
        <wuc-input-date-picker
            formControlName="endDate"
            [selectPastDates]="false"
            [selectToday]="false"
        ></wuc-input-date-picker>
        <wuc-input-alert *ngIf="endDate.touched && endDate.hasError('required')">
            Vul uw einddatum in.
        </wuc-input-alert>
    </wuc-form-field>
    <p *ngIf="errors?.length">
        <wuc-card
            cardStyle="tertiary"
            padding="medium"
        >
            <wuc-list icon="cross">
                <wuc-list-item
                    *ngFor="let error of errors"
                >{{ error.message }}</wuc-list-item>
            </wuc-list>
        </wuc-card>
    </p>
    <wuc-form-field>
        <wuc-form-field-label></wuc-form-field-label>
        <wuc-button
            [isSubmitButton]="true"
            [disabled]="isDisabled"
            [isFullWidth]="true"
        >Opzeggen
        </wuc-button>
    </wuc-form-field>
</form>
